import { ProcessedManagerTemplate } from 'src/models/employerMailTemplates';

export const getInitialTemplateText = (templates: ProcessedManagerTemplate[]) => {
    return templates.find((template) => template.isSelected)?.template;
};

export const getInitialTemplateId = (templates: ProcessedManagerTemplate[]) => {
    return templates.find((template) => template.isSelected)?.id;
};
